import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { useMemo, useState } from 'react';

import ListItemsTable from '../component/list/table.js';
import { LIST_TYPES } from '../shared.js';

function ListsPage() {
    const [selectedListType, setSelectedListType] = useState('');

    const items = useMemo(() => {
        return [
            ...Object.values(LIST_TYPES).map((o) => {
                return {
                    label: o,
                    value: o
                };
            })
        ];
    }, []);

    const onChangeListType = ({ value }) => {
        setSelectedListType(value);
    };

    return (
        <Card title="Lists Management" className="pageCard">
            <div className="flex justify-content-between">
                <Dropdown
                    value={selectedListType}
                    options={items}
                    onChange={onChangeListType}
                    placeholder="Select a List Table"
                />
            </div>

            {!selectedListType ? (
                <p>Please select a list</p>
            ) : (
                <ListItemsTable type={selectedListType} />
            )}
        </Card>
    );
}

export default ListsPage;
